// extracted by mini-css-extract-plugin
module.exports = {"section":"EntryRequirementsInclusionDetail_section__Oy67b","source":"EntryRequirementsInclusionDetail_source__m7jrO"};